import React, { useState } from 'react';
import { BASE_URL } from '../config/api'; // Assuming BASE_URL is correctly defined
import { useNavigate } from 'react-router-dom';

const AddVisit = () => {
    const [customerName, setCustomerName] = useState('');
    const [contactPersonName, setContactPersonName] = useState('');
    const [contactNumber, setContactNumber] = useState('');
    const [description, setDescription] = useState('');
    const [visitingCardImage, setVisitingCardImage] = useState(null); // For image upload
    const navigate = useNavigate();

    // Handle file change (visiting card image)
    const handleImageChange = (event) => {
        setVisitingCardImage(event.target.files[0]);
    };

    // Handle form submission
    const handleSubmit = async (event) => {
        event.preventDefault();

        const formData = new FormData();
        formData.append('customer_name', customerName);
        formData.append('contact_person_name', contactPersonName);
        formData.append('contact_number', contactNumber);
        formData.append('description', description);
        if (visitingCardImage) {
            formData.append('visiting_card_image', visitingCardImage);
        }

        try {
            const response = await fetch(`${BASE_URL}visits`, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                },
                body: formData,
            });

            const data = await response.json();
            if (data.status === 1) {
                alert('Visit added successfully!');
                navigate('/VisitsList'); // Navigate to visit list after successful addition
            } else {
                alert('Failed to add visit. Please try again.');
            }
        } catch (error) {
            console.error('Error adding visit:', error);
            alert('An error occurred while adding the visit.');
        }
    };

    return (
        <div id="main">
            <header className="mb-3">
                <a href="#" className="burger-btn d-block d-xl-none">
                    <i className="bi bi-justify fs-3"></i>
                </a>
            </header>

            <div className="page-heading">
                <div className="page-title">
                    <div className="row">
                        <div className="col-12 col-md-6 order-md-1 order-last">
                            <h3>Add Visit</h3>
                        </div>
                    </div>
                </div>
            </div>

            <section className="section">
                <div className="row">
                    <div className="col-12 col-md-12">
                        <div className="card">
                            <div className="card-header">
                                <h4 className="card-title">Add Visit Details</h4>
                            </div>
                            <div className="card-body">
                                <form onSubmit={handleSubmit}>
                                    {/* Customer Name */}
                                    <div className="mb-3">
                                        <label htmlFor="customerName" className="form-label">Firm Name</label>
                                        <input
                                            type="text"
                                            id="customerName"
                                            className="form-control"
                                            value={customerName}
                                            onChange={(e) => setCustomerName(e.target.value)}
                                            required
                                        />
                                    </div>

                                    {/* Contact Person Name */}
                                    <div className="mb-3">
                                        <label htmlFor="contactPersonName" className="form-label">Contact Person Name</label>
                                        <input
                                            type="text"
                                            id="contactPersonName"
                                            className="form-control"
                                            value={contactPersonName}
                                            onChange={(e) => setContactPersonName(e.target.value)}
                                            required
                                        />
                                    </div>

                                    {/* Contact Number */}
                                    <div className="mb-3">
                                        <label htmlFor="contactNumber" className="form-label">Contact Number</label>
                                        <input
    type="text" // Use text type to fully control the input
    id="contactNumber"
    className="form-control"
    value={contactNumber}
    onChange={(e) => {
        const value = e.target.value;

        // Allow only digits and limit the input to 10 digits
        if (/^\d{0,10}$/.test(value)) {
            setContactNumber(value); // Update state only if the value matches the condition
        }
    }}
    
    maxLength={10} // Restrict the input length to 10 digits
/>

                                    </div>

                                    {/* Description */}
                                    <div className="mb-3">
                                        <label htmlFor="description" className="form-label">Description</label>
                                        <textarea
                                            id="description"
                                            className="form-control"
                                            value={description}
                                            onChange={(e) => setDescription(e.target.value)}
                                            required
                                        />
                                    </div>

                                    {/* Visiting Card Image */}
                                    <div className="mb-3">
                                        <label htmlFor="visitingCardImage" className="form-label">Visiting Card Image</label>
                                        <input
                                            type="file"
                                            id="visitingCardImage"
                                            className="form-control"
                                            accept="image/*"
                                            onChange={handleImageChange}
                                        />
                                    </div>

                                    <div className="text-end">
                                        <button type="submit" className="btn btn-primary">Add Visit</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default AddVisit;
